import Button from "components/controls/Button";
import {
    StyledMessagedButton,
    StyledMessagePage,
    StyledMessagePageContainer,
    StyledMessagePageLogo,
    StyledMessagePageLogoContainer,
    StyledMessagePageText,
    StyledMessagePageTextContainer,
} from "shared/styled/message-page.styled";
import { useHistory } from "react-router-dom";
import i18next, { t } from "i18next";
import { ConditionalRender } from "../../../../../../components/layout/ConditionalRender";

interface NewOpportunitySuccessProps {
    onCreateAnother: () => void;
}

export const NewOpportunitySuccess = ({
    onCreateAnother,
}: NewOpportunitySuccessProps) => {
    const history = useHistory();

    function handleGoodPracticeClick() {
        history.push("/goodpractice/new");
    }

    function handleIssueClick() {
        history.push("/issue/new");
    }

    function handleNearMissClick() {
        history.push("/nearmiss/new");
    }

    return (
        <StyledMessagePageContainer>
            <StyledMessagePage>
                <StyledMessagePageLogoContainer>
                    <StyledMessagePageLogo />
                </StyledMessagePageLogoContainer>
                <StyledMessagePageTextContainer>
                    <StyledMessagePageText>
                        {
                            "Thank you for your Opportunity report. This has been submitted for evaluation, and to your depot if one was entered."
                        }
                    </StyledMessagePageText>
                </StyledMessagePageTextContainer>
                <StyledMessagePageText>
                    <StyledMessagedButton>
                        <Button
                            text={t("ObservationPage.NewNearMiss")}
                            onClick={handleNearMissClick}
                        />
                    </StyledMessagedButton>
                    <StyledMessagedButton>
                        <Button
                            text={t("ObservationPage.NewGoodPractice")}
                            onClick={handleGoodPracticeClick}
                        />
                    </StyledMessagedButton>
                    <ConditionalRender condition={i18next.language === "gb"}>
                        <StyledMessagedButton>
                            <Button text={t("ObservationPage.NewIssue")} onClick={handleIssueClick} />
                        </StyledMessagedButton>
                        <StyledMessagedButton>
                            <Button text={t("ObservationPage.NewOpportunity")} onClick={onCreateAnother} />
                        </StyledMessagedButton>
                    </ConditionalRender>
                </StyledMessagePageText>
            </StyledMessagePage>
        </StyledMessagePageContainer>
    );
};

